import { Suspense } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { usePatientsCopy } from "@/features/i18n/patientsCopy";
import { DiaryUpdateTemplatePicker } from "@/features/patients/update/DiaryUpdateTemplatePicker";

const DiaryUpdateTemplatesPage = () => {
    const copy = usePatientsCopy();
    const { diaryId } = Route.useParams();

    return (
        <div className="space-y-8 min-w-0 max-w-3xl">
            <Suspense
                fallback={
                    <div className="py-12 text-muted-foreground text-sm text-center">{copy.loadingTemplates}</div>
                }
            >
                <DiaryUpdateTemplatePicker
                    diaryId={diaryId}
                    title={{
                        words: copy.chooseTemplate,
                        description: copy.chooseTemplateDescription,
                    }}
                />
            </Suspense>
        </div>
    );
};

export const Route = createFileRoute("/_app/patients/$diaryId/update/templates")({
    component: DiaryUpdateTemplatesPage,
});
